<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
import '../src/style/base.scss'

export default {
  name: 'App',
  mounted(){
    document.addEventListener('keydown', function (event) {
		if ((event.ctrlKey === true || event.metaKey === true)
			&& (event.which === 61 || event.which === 107
				|| event.which === 173 || event.which === 109
				|| event.which === 187 || event.which === 189)) {
			event.preventDefault();
		}
	}, false);
	// Chrome IE 360
	window.addEventListener('mousewheel', function (event) {
		if (event.ctrlKey === true || event.metaKey) {
			event.preventDefault();
		}
	}, { passive: false });

	//firefox
	window.addEventListener('DOMMouseScroll', function (event) {
		if (event.ctrlKey === true || event.metaKey) {
			event.preventDefault();
		}
	}, { passive: false });
  }
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  width: 100%;
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/App.vue